import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from 'flarum/common/components/Button';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import saveVote from './helpers/saveVote';
export default function useAlternatePostVoteLayout() {
  extend(CommentPost.prototype, 'actionItems', function (items) {
    if (!app.forum.attribute('fof-gamification.altPostVotingUi')) {
      return;
    }
    if (this.attrs.post.isHidden()) return;
    items.remove('votes');
  });
  extend(CommentPost.prototype, 'classes', function (classes) {
    if (!app.forum.attribute('fof-gamification.altPostVotingUi')) {
      return;
    }
    if (this.attrs.post.isHidden()) return;
    const upvotesOnly = app.forum.attribute('fof-gamification.upVotesOnly');
    classes.push('votesAlternativeLayout');
    if (upvotesOnly) {
      classes.push('votesUpvotesOnly');
    }
  });
  extend(CommentPost.prototype, 'oninit', function () {
    if (!app.forum.attribute('fof-gamification.altPostVotingUi')) {
      return;
    }
    this.voteLoading = false;
  });
  extend(CommentPost.prototype, 'sideItems', function (items) {
    if (!app.forum.attribute('fof-gamification.altPostVotingUi')) {
      return;
    }
    const post = this.attrs.post;
    if (post.isHidden()) return;
    if (!post.canSeeVotes()) return;
    const hasDownvoted = post.hasDownvoted();
    const hasUpvoted = post.hasUpvoted();
    const icon = app.forum.attribute('fof-gamification.iconName');
    const upvotesOnly = app.forum.attribute('fof-gamification.upVotesOnly');
    const canSeeVotes = post.canSeeVotes();

    // We set canVote to true for guest users so that they can access the login by clicking the button
    const canVote = !app.session.user || post.canVote();
    const onclick = (upvoted, downvoted) => saveVote(post, upvoted, downvoted, val => {
      this.voteLoading = val;
    });
    items.add('votes', m("div", {
      className: "Post-votes alternateLayout",
      "data-upvotes-only": upvotesOnly
    }, m(Button, {
      className: "Post-voteButton Post-voteButton--up Button Button--icon Button--text",
      icon: "fas fa-fw fa-".concat(icon, "-up"),
      "data-active": hasUpvoted,
      disabled: !canVote || this.voteLoading || !canSeeVotes,
      onclick: () => onclick(!hasUpvoted, false),
      "aria-label": app.translator.trans('fof-gamification.forum.post.upvote_button')
    }), m("span", {
      class: "Post-voteCount"
    }, abbreviateNumber(post.votes() || 0)), !upvotesOnly && m(Button, {
      className: "Post-voteButton Post-voteButton--down Button Button--icon Button--text",
      icon: "fas fa-fw fa-".concat(icon, "-down"),
      "data-active": hasDownvoted,
      disabled: !canVote || this.voteLoading,
      onclick: () => onclick(false, !hasDownvoted),
      "aria-label": app.translator.trans('fof-gamification.forum.post.downvote_button')
    }), this.voteLoading && m(LoadingIndicator, {
      display: "inline",
      size: "small"
    })));
  });
}